/* Comparison-list controller for the printable sticker size guide. */
(function (global) {
  'use strict';

  var MAX_SELECTIONS = 12;

  function createStore(pdfApi) {
    if (!pdfApi || typeof pdfApi.normalizeSelection !== 'function') {
      throw new Error('The sticker size PDF generator is unavailable.');
    }

    var active = null;
    var selections = [];
    var paper = 'letter';

    function copy(selection) {
      return selection ? {
        id: selection.id,
        shape: selection.shape,
        widthIn: selection.widthIn,
        heightIn: selection.heightIn,
        label: selection.label,
      } : null;
    }

    return {
      setActive: function (input) {
        active = pdfApi.normalizeSelection(input);
        return copy(active);
      },
      addActive: function () {
        if (!active) return { ok: false, reason: 'empty' };
        if (selections.some(function (selection) { return selection.id === active.id; })) {
          return { ok: false, reason: 'duplicate' };
        }
        if (selections.length >= MAX_SELECTIONS) {
          return { ok: false, reason: 'limit' };
        }
        selections.push(copy(active));
        return { ok: true, selection: copy(active) };
      },
      remove: function (id) {
        selections = selections.filter(function (selection) {
          return selection.id !== id;
        });
      },
      clear: function () {
        selections = [];
      },
      setPaper: function (nextPaper) {
        if (!pdfApi.PAPERS[nextPaper]) throw new Error('Choose a supported paper size.');
        paper = nextPaper;
      },
      getPageCount: function () {
        return selections.length ? pdfApi.packSelections(selections, paper).length : 0;
      },
      getSnapshot: function () {
        return {
          active: copy(active),
          selections: selections.map(copy),
          paper: paper,
          maxSelections: MAX_SELECTIONS,
        };
      },
    };
  }

  function formatMm(value) {
    var rounded = Math.round(Number(value) * 25.4 * 10) / 10;
    return String(rounded);
  }

  function init(root, doc) {
    var pdfApi = global.SparkSizeGuidePdf;
    if (!root || !doc || !pdfApi) return;

    var addButton = root.querySelector('[data-size-comparison-add]');
    var list = root.querySelector('[data-size-comparison-list]');
    var empty = root.querySelector('[data-size-comparison-empty]');
    var count = root.querySelector('[data-size-comparison-count]');
    var clearButton = root.querySelector('[data-size-comparison-clear]');
    var downloadButton = root.querySelector('[data-size-comparison-download]');
    var pageStatus = root.querySelector('[data-size-comparison-pages]');
    var status = root.querySelector('[data-size-comparison-status]');
    var paperInputs = [].slice.call(root.querySelectorAll('input[name="spark-size-guide-paper"]'));
    if (!addButton || !list || !clearButton || !downloadButton || !status) return;

    var store = createStore(pdfApi);
    var clearArmed = false;
    var clearTimer = null;

    function announce(message) {
      status.textContent = message || '';
    }

    function resetClearConfirmation() {
      clearArmed = false;
      clearButton.textContent = 'Clear all';
      if (clearTimer) global.clearTimeout(clearTimer);
      clearTimer = null;
    }

    function millimetreLabel(selection) {
      return formatMm(selection.widthIn) + ' × ' + formatMm(selection.heightIn) + ' mm';
    }

    function appendSelection(selection) {
      var item = doc.createElement('li');
      item.className = 'spark-size-guide__comparison-item';

      var shape = doc.createElement('span');
      shape.className = 'spark-size-guide__comparison-shape is-' + selection.shape;
      shape.setAttribute('aria-hidden', 'true');

      var copy = doc.createElement('span');
      copy.className = 'spark-size-guide__comparison-item-copy';
      var label = doc.createElement('strong');
      label.textContent = selection.label;
      var millimetres = doc.createElement('small');
      millimetres.textContent = millimetreLabel(selection);
      copy.appendChild(label);
      copy.appendChild(millimetres);

      var remove = doc.createElement('button');
      remove.type = 'button';
      remove.className = 'spark-size-guide__comparison-remove';
      remove.textContent = 'Remove';
      remove.setAttribute('aria-label', 'Remove ' + selection.label);
      remove.addEventListener('click', function () {
        store.remove(selection.id);
        resetClearConfirmation();
        render();
        announce(selection.label + ' removed.');
      });

      item.appendChild(shape);
      item.appendChild(copy);
      item.appendChild(remove);
      list.appendChild(item);
    }

    function render() {
      var snapshot = store.getSnapshot();
      var duplicate = !!snapshot.active && snapshot.selections.some(function (selection) {
        return selection.id === snapshot.active.id;
      });
      var atLimit = snapshot.selections.length >= snapshot.maxSelections;

      addButton.disabled = !snapshot.active || duplicate || atLimit;
      addButton.textContent = duplicate ? 'Already added' : (atLimit ? '12 sizes added' : 'Add this size');

      list.innerHTML = '';
      snapshot.selections.forEach(appendSelection);
      if (empty) empty.hidden = snapshot.selections.length > 0;
      if (count) count.textContent = snapshot.selections.length + ' of ' + snapshot.maxSelections + ' sizes';
      clearButton.disabled = snapshot.selections.length === 0;
      if (!snapshot.selections.length) resetClearConfirmation();

      downloadButton.disabled = snapshot.selections.length === 0;
      if (pageStatus) pageStatus.textContent = '';
      if (snapshot.selections.length) {
        try {
          var pages = store.getPageCount();
          if (pageStatus) {
            pageStatus.textContent = 'Your ' + (snapshot.paper === 'a4' ? 'A4' : 'Letter') +
              ' PDF will use ' + pages + ' ' + (pages === 1 ? 'page.' : 'pages.');
          }
        } catch (error) {
          downloadButton.disabled = true;
          if (pageStatus) pageStatus.textContent = error.message;
        }
      }
    }

    doc.addEventListener('spark:size-guide-selection', function (event) {
      try {
        store.setActive(event.detail);
        render();
      } catch (error) {
        announce(error.message);
      }
    });

    addButton.addEventListener('click', function () {
      var result = store.addActive();
      if (result.reason === 'duplicate') return announce('Already added. Choose another shape or size to compare.');
      if (result.reason === 'limit') return announce('You can compare up to 12 sizes at a time.');
      if (!result.ok) return announce('Choose a shape and size first.');
      resetClearConfirmation();
      render();
      announce(result.selection.label + ' added to your printable comparison.');
    });

    clearButton.addEventListener('click', function () {
      if (!clearArmed) {
        clearArmed = true;
        clearButton.textContent = 'Confirm clear';
        announce('Press Confirm clear to remove every selected size.');
        clearTimer = global.setTimeout(resetClearConfirmation, 5000);
        return;
      }
      store.clear();
      resetClearConfirmation();
      render();
      announce('Your printable comparison is empty.');
    });

    paperInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        if (!input.checked) return;
        store.setPaper(input.value);
        render();
        announce((input.value === 'a4' ? 'A4' : 'Letter') + ' paper selected.');
      });
    });

    downloadButton.addEventListener('click', function () {
      var snapshot = store.getSnapshot();
      try {
        pdfApi.downloadPdf(snapshot.selections, snapshot.paper, 'sparkstickers-size-comparison.pdf');
        announce('Your true-scale comparison PDF is downloading.');
      } catch (error) {
        announce(error.message + ' Your selected sizes are still here.');
      }
    });

    root.hidden = false;
    render();
  }

  function ready(callback) {
    var doc = global.document;
    if (!doc) return;
    if (doc.readyState !== 'loading') callback(doc);
    else doc.addEventListener('DOMContentLoaded', function () { callback(doc); }, { once: true });
  }

  global.SparkSizeGuideComparison = {
    createStore: createStore,
    init: init,
  };

  ready(function (doc) {
    [].slice.call(doc.querySelectorAll('[data-size-comparison]')).forEach(function (root) {
      init(root, doc);
    });
  });
})(typeof window !== 'undefined' ? window : globalThis);
